import React, { useEffect, useState } from 'react';
import {
  DropdownOption,
  PaginatedSingleDropdown,
  SimpleFormSingleDropdown,
} from '../../shared/form/Fields';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Label, Link } from '@grnhse/seedling/lib/birch/typography';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import { withLocalePrefix } from '../../../shared/utils/translation';
import type { TemplateOption } from '../../shared/types';
import { recursiveMapToItems } from 'candidate_profile_redesign/shared/utils';

const t = withLocalePrefix('candidate_profile_redesign.modals');

export const TemplateField = ({
  templateOptions,
}: {
  templateOptions: TemplateOption[];
}) => {
  if (!templateOptions || templateOptions.length === 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <Label>{t('email.template')}</Label>
        <Link href="/account/email_templates" target="_blank">
          {t('email.configure_email_template')}
        </Link>
      </div>
    );
  }
  return (
    <SimpleFormSingleDropdown
      items={templateOptions}
      name={`template`}
      label={t('email.template_optional')}
      placeholder={t('email.template_placeholder')}
    />
  );
};

const OfficeAndTemplateFields = ({
  officeOptionsPath,
  templateOptions,
  showOfficeSpecificTemplateDropdown,
}: {
  officeOptionsPath: string;
  templateOptions: Array<TemplateOption>;
  showOfficeSpecificTemplateDropdown: boolean;
}) => {
  const { watch, setValue, getValues } = useFormContext();

  const office = watch('office');
  const [templates, setTemplates] = useState(templateOptions);

  const filterOptions = (
    options: TemplateOption[],
    selectedOffice?: DropdownOption
  ) => {
    if (!selectedOffice) {
      return options;
    }

    return options.filter(
      (option) =>
        option.anywhere ||
        option.office_ids.some((id) => id.toString() === selectedOffice.value)
    );
  };

  useEffect(() => {
    const filteredTemplates = filterOptions(templateOptions, office);
    setTemplates(filteredTemplates);
  }, [office, templateOptions, setValue, getValues]);
  return (
    <Stack>
      {showOfficeSpecificTemplateDropdown && (
        <PaginatedSingleDropdown
          name="office"
          label={t('email.office')}
          getOptionsUrl={officeOptionsPath}
          placeholder={t('email.default_office_text')}
          transformValues={(data) => recursiveMapToItems(data.results, false)}
          pageSize={200}
        />
      )}
      <TemplateField templateOptions={templates} />
    </Stack>
  );
};

export default OfficeAndTemplateFields;
